"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.display = display;
var _sendMessage = require("../send-message");
var _context = require("../context");
var _error = require("../error");
var _show = require("./show");
/*
* Copyright (c) 2020 Wells Fargo, All rights reserved.
*
* This software is the confidential and proprietary information of Wells Fargo
* bank. ('Confidential Information'). You shall not disclose such Confidential
* Information and shall use it only in accordance with the terms of the license
* agreement you entered into with WellsFargo.
*/

/**
 * Resize IFrame Handler
 * - resizes the SDK iframe
 *
 * @module core-bootstrap-command-display
 */

/**
 * Displays various flows in the SDK
 *
 * @param {string} screenName The name of the screen flow to display from dispatch.screens
 * @param {object} [opts] optional options for display
 * @param {string} id The ID of the target iframe SDK
 */
function display(screenName, opts, id) {
  var iframeEntry = (0, _context.getIframeConfiguration)(id);
  if (!iframeEntry) {
    (0, _error.handleError)('Unrecognized IFRAME/SDK ID.');
    return;
  }
  if (!screenName) {
    (0, _error.handleError)('A screenName argument must be provided.', iframeEntry);
    return;
  }
  var payload = {
    screen: screenName
  };
  if (opts) {
    payload.opts = opts;
  }
  (0, _sendMessage.sendMessage)('display', payload, id);
  (0, _show.showElement)(iframeEntry.element);
}
//# sourceMappingURL=display.js.map